module.exports = __webpack_public_path__ + "staticcomp/img/share.32a978a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/3/share.jpg
// module id = vuxN
// module chunks = 39